import { makeStyles } from '@material-ui/core';
import { Colors } from '../../utils';

const makeClasses = makeStyles(theme => ({
  selectContainer: {
    width: 'auto',
    textAlign: 'left',
    fontSize: theme.fontSize.M,
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentText,

    '&::before': {
      borderBottomColor: `${Colors.rgb.contentLine} !important`,
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  alignRight: {
    textAlign: 'right',

    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  selectOption: {
    fontSize: theme.fontSize.M,
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentText,
  },
}));

export default makeClasses;
